module.exports = __webpack_public_path__ + "@/assets/img/04.deb04006.svg";